import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
// mantine
import { Radio } from '@mantine/core';
import { useDebouncedState } from '@mantine/hooks';
// utils
import type { TProfile, TCustomerStatus } from '@newo/api/gateway';
import { useCustomerSetStatusMutation } from '@/services/customer/customer/customer.queries.ts';
import { QUERY_KEYS } from '@/services/customer/profile/profile.queries.ts';

interface AdvancedProps {
    profile: TProfile;
}

const DEBOUNCE_TIMEOUT = 200;

const Advanced = ({ profile }: AdvancedProps) => {
    const [status, setStatus] = useDebouncedState<TCustomerStatus>(
        profile.status,
        DEBOUNCE_TIMEOUT
    );
    const queryClient = useQueryClient();
    const { mutate, isPending } = useCustomerSetStatusMutation();

    const customerStatus = profile.status;
    const customerId = profile.id;

    useEffect(() => {
        if (status !== customerStatus) {
            mutate(
                {
                    customerId,
                    data: { status }
                },
                {
                    onSuccess: () => {
                        queryClient.invalidateQueries({
                            queryKey: QUERY_KEYS.getProfile()
                        });
                    }
                }
            );
        }
    }, [status, customerId, customerStatus, mutate, queryClient]);

    const handleStatusChange = (value: string | null) => {
        if (value) {
            setStatus(value as TCustomerStatus);
        }
    };

    return (
        <div className="flex flex-col gap-4">
            <Radio.Group
                label="Account status"
                value={status}
                onChange={handleStatusChange}
            >
                <div className="flex flex-col gap-4 pt-4">
                    <Radio
                        disabled={isPending}
                        label="Temporal"
                        value="temporal"
                    />
                    <Radio
                        disabled={isPending}
                        label="Permanent"
                        value="permanent"
                    />
                </div>
            </Radio.Group>
        </div>
    );
};

export default Advanced;
